// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lf-0";
export var buttonContainer = "_lf-3";
export var cancelButton = "_lf-4";
export var headerSection = "_lf-6";
export var headerTitle = "_lf-9";
export var messageSideLeft = "_lf-1";
export var messageSideRight = "_lf-2";
export var orderNumberContainer = "_lf-7";
export var orderNumberLabel = "_lf-8";
export var submitButton = "_lf-5";